/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import { ActivateQuoteTermModel, activateTerm } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { ActiveQuoteTermParameter } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = ActiveQuoteTermParameter & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, ActivateQuoteTermModel>;

export const PopulateApiParameters: HandlerType = props => {
    const { id } = props.parameter;
    props.apiParameter = {
        id
    };
};

export const ActivateTerm: HandlerType = async props => {
    try {
        await activateTerm(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};
export const LoadTerms: HandlerType = props => {
    props.dispatch(searchFilterTerms({ queryParams: { page: 1 } }));
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, ActivateTerm, LoadTerms, ExecuteOnSuccess];

const activateQuoteTerm = createHandlerChainRunner(chain, "ActivateQuoteTerm");
export default activateQuoteTerm;